<!--
  @author:han.saibo
  @time:2023/12/14
  @disc:营销政策汇总
 -->
 <template>
    <div @keyup.enter="enterSearch">
      <el-form :model="form" ref="form" class="table-search-bar" inline>
        <el-form-item label="经营组织" prop="orgId">
          <el-select v-model="form.orgId" placeholder="请选择">
            <el-option
              v-for="item in orgIds"
              :key="item.id"
              :label="item.label"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="主体客户" prop="mainCustomer">
          <el-input v-model="form.mainCustomer" placeholder="请输入主体客户名称"></el-input>
        </el-form-item>
        <el-form-item label="子客户" prop="subCustomers">
          <el-input v-model="form.subCustomers " placeholder="请输入子客户名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
          <el-button type="primary" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
       <span>每月5号凌晨2点更新报表数据</span>
      <el-table
        border
        :data="list"
        tooltip-effect="light"
        style="width: 100%">
        <el-table-column
          align="center"
          type="index"
          width="50">
        </el-table-column>
        <el-table-column
          prop="orgName"
          label="经营组织"
          :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
          prop="mainCustomer"
          label="主体客户"
          :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
          prop="subCustomers"
          label="子客户"
          :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
          prop="executionVolume"
          label="执行量汇总"
          :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
          prop="january"
          label="一月"
          :show-overflow-tooltip="true">
        </el-table-column>

        <el-table-column
          prop="february"
          label="二月"
          :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
          prop="march"
          label="三月"
          :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
          prop="april"
          label="四月"
          :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
          prop="may"
          label="五月"
          :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
          prop="june"
          label="六月"
          :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
          prop="july"
          label="七月"
          :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
          prop="august"
          label="八月"
          :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
          prop="september"
          label="九月"
          :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
          prop="october"
          label="十月"
          :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
          prop="november"
          label="十一月"
          :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
          prop="december"
          label="十二月"
          :show-overflow-tooltip="true">
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20 ,50, 100]"
        :page-size="listState.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="listState.total"
        :current-page="listState.pageNo"
        background>
      </el-pagination>
      <el-row class="export-row" type="flex" justify="end">
          <el-col :span="3">
          每页
          <el-select class="width100" v-model="exportForm.size" @change="handleExportSizeChange">
            <el-option v-for="item in sizeOptions"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
          条
        </el-col>
        <el-col :span="3">
          第
          <el-select class="width100" v-model="exportForm.page">
            <el-option v-for="item in pageOptions"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
          页
        </el-col>
        <el-col :span="3">
          <el-button type="primary" @click="handleExportCSV">导出为CSV文件</el-button>
        </el-col>
      </el-row>
    </div>
  </template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'marketingPolicyCollect',
  components: {},
  data () {
    return {
      form: {
        mainCustomer: '',
        subCustomers: '',
        orgId: ''
      },
      exportForm: {
        size: 1000,
        page: 1
      },
      orgIds: [
        {
          id: '',
          label: '全部'
        },
        {
          id: '1094530434974004277',
          label: '山东京博新能源控股发展有限公司'
        },
        {
          id: '1194877555086111111',
          label: '山东省石油化工有限公司'
        }],
      sizeOptions: [
        {
          label: '1000',
          value: 1000
        },
        {
          label: '5000',
          value: 5000
        },
        {
          label: '10000',
          value: 10000
        },
        {
          label: '20000',
          value: 20000
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      list: 'getMarketingPolicyCollectList',
      listState: 'getMarketingPolicyCollectListState'
    }),
    pageOptions () {
      const total = this.listState.total
      const size = this.exportForm.size
      let totalPage = Math.floor(total / size)
      if (total % size) {
        totalPage++
      }
      const arr = []
      for (let index = 1; index <= totalPage; index++) {
        arr.push({
          label: index,
          value: index
        })
      }
      return arr
    }
  },
  mounted () {
    this.handleSearch()
  },
  methods: {
    ...mapActions(['getMarketingPolicyCollectList', 'exportMarketingPolicyCollect']),
    enterSearch (e) { // 回车搜索
      if (e.target.form && e.target.nodeName === 'INPUT') {
        this.handleSearch()
      }
    },
    handleSizeChange (val) {
      this.getMarketingPolicyCollectList({ pageNo: 1, pageSize: val })
    },
    handleCurrentChange (val) {
      this.getMarketingPolicyCollectList({ pageNo: val })
    },
    handleSearch () {
      const params = {
        ...this.form,
        pageNo: 1
      }
      this.getMarketingPolicyCollectList(params)
    },
    handleReset () {
      this.$refs['form'].resetFields()
      this.handleSearch()
    },
    // 导出每页条数变动监听
    handleExportSizeChange (val) {
      this.exportForm.page = 1
    },
    handleExportCSV () {
      if (!Array.isArray(this.list) || this.list.length === 0) {
        this.$message({
          message: '暂无数据',
          type: 'warning'
        })
        return
      }
      this.$confirm('是否确认导出', '导出', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const params = {
          ...this.form,
          pageNo: this.exportForm.page,
          pageSize: this.exportForm.size
        }
        this.exportMarketingPolicyCollect({ ...params }).then((res) => {
          function createDownloadFile () {
            let blob = new Blob([res])
            let link = document.createElement('a')
            link.download = '营销政策汇总信息.xls'
            link.style.display = 'none'
            link.target = '_Blank'
            link.href = window.URL.createObjectURL(blob)
            document.body.appendChild(link)
            link.click()
            window.URL.revokeObjectURL(link.href)
          }
          createDownloadFile()
          this.$message.success('导出成功')
        })
      }).catch(() => { })
    }
  }
}
</script>
  <style lang="scss" scoped>
  .export-row {
    margin-top: 10px;
  }
  .width100 {
    width: 100px;
  }
  .blue{
    color:#008ef3;
  }

  </style>
